import { useState } from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify'
import FileExplorer from '../FileExplorer/FileExplorer'
import Auth from '../GoogleAuth/GoogleAuth'
import FileUploadModal from '../FileUploadModal/FileUploadModal'
import FolderCreationModal from '../FolderCreationModal/FolderCreationModal'
import SettingsModal from '../SettingsModal/SettingsModal'
import api from '../../api/storage'

function App() {
  const [idToken, setIdToken] = useState('')
  const [profile, setProfile] = useState({})

  const [explorerPath, setExplorerPath] = useState('') // Current file explorer path
  const [doRefresh, refreshExplorer] = useState(true)

  const [fileUploadOpen, setFileUploadOpen] = useState(false)
  const [folderCreatorOpen, setFolderCreatorOpen] = useState(false)
  const [settingsOpen, setSettingsOpen] = useState(false)

  return (
    <div className="App">
      <Auth setIdToken={async (t, d) => {
        api.idToken = t
        await api.setEndpoint(d)
        setIdToken(t)
      }} setProfile={setProfile} />
      <section className='app-content'>
        <FileExplorer
          idToken={idToken}
          profile={profile}
          setExplorerPath={setExplorerPath}
          doRefresh={doRefresh}
          didRefresh={() => refreshExplorer(false)}
          openFileUpload={() => setFileUploadOpen(true)}
          openFolderCreator={() => setFolderCreatorOpen(true)}
          openSettings={() => setSettingsOpen(true)}
        />
      </section>
      <FileUploadModal
        open={fileUploadOpen}
        closeModal={() => { setFileUploadOpen(false); refreshExplorer(true) }}
        path={explorerPath}
        onSuccess={() => { setFileUploadOpen(false); refreshExplorer(true) }}
      />
      <FolderCreationModal
        open={folderCreatorOpen}
        closeModal={() => setFolderCreatorOpen(false)}
        path={explorerPath}
        onSuccess={() => { setFolderCreatorOpen(false); refreshExplorer(true) }}
      />
      <SettingsModal
        open={settingsOpen}
        closeModal={() => setSettingsOpen(false)}
      />
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
